import { defineMessages } from 'react-intl'

import { DOW } from './constants'

export const dowMessages = defineMessages({
  [DOW.NA]: {
    id: 'dow.na',
    defaultMessage: 'N/A'
  },
  [DOW.MONDAY]: {
    id: 'dow.monday',
    defaultMessage: 'Mon'
  },
  [DOW.TUESDAY]: {
    id: 'dow.tueday',
    defaultMessage: 'Tue'
  },
  [DOW.WEDNESDAY]: {
    id: 'dow.wednesday',
    defaultMessage: 'Wed'
  },
  [DOW.THURSDAY]: {
    id: 'dow.thursday',
    defaultMessage: 'Thu'
  },
  [DOW.FRIDAY]: {
    id: 'dow.friday',
    defaultMessage: 'Fri'
  },
  [DOW.SATURDAY]: {
    id: 'dow.saturday',
    defaultMessage: 'Sat'
  },
  [DOW.SUNDAY]: {
    id: 'dow.sunday',
    defaultMessage: 'Sun'
  }
})
